import {Slide} from '@aboutyou/transitions';
import {
  Drawer,
  GenericIconName,
  ModalDialog,
  desktopAndUpLinaria,
  tabletAndDownLinaria,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useRef} from 'react';
import {HeaderCouponWalletButton} from '../../../features/Coupons/CouponWallet/HeaderCouponWalletButton/HeaderCouponWalletButton';
import {HeaderCoinsWalletButton} from '../../Coins/HeaderCoinsWalletButton/HeaderCoinsWalletButton';
import {NotificationCenter} from '../../NotificationCenter/NotificationCenter';
import {NotificationCenterDrawerHeader} from '../../NotificationCenter/Stream/NotificationCenterDrawerHeader';
import {useTrackHeaderOriginClick} from '../hooks/useOriginClickTrackingFunction';
import {IconMetaNavigationItemBasket} from './IconMetaNavigationItemBasket';
import {IconMetaNavigationItemSearch} from './IconMetaNavigationItemSearch';
import {IconMetaNavigationItemUser} from './IconMetaNavigationItemUser/IconMetaNavigationItemUser';
import {IconMetaNavigationItemWishlist} from './IconMetaNavigationItemWishlist';

interface IconMetaNavigationItemsProps {
  notificationBellRef: React.RefObject<HTMLDivElement | null>;
  showSearchIcon: boolean;
  onSearchIconClick: () => void;
  className?: string;
}

export const IconMetaNavigationItems: React.FC<
  IconMetaNavigationItemsProps
> = ({className, notificationBellRef, onSearchIconClick, showSearchIcon}) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const trackOriginClick = useTrackHeaderOriginClick();

  const handleClick: React.MouseEventHandler = event => {
    event.preventDefault();
    event.stopPropagation();
    trackOriginClick();
  };

  return (
    <Wrapper data-testid="iconMetaNavigationItems" className={className}>
      <IconAndContentWrapper ref={wrapperRef}>
        <IconMetaNavItemsWrapper>
          <SearchIconWrapper>
            <Slide mounted={showSearchIcon} duration={300} direction="left">
              <div>
                <IconMetaNavigationItemSearch onClick={onSearchIconClick} />
              </div>
            </Slide>
          </SearchIconWrapper>

          <HeaderCoinsWalletButton />
          <HeaderCouponWalletButton />
          <IconMetaNavigationItemUser onClick={handleClick} />
          <NotificationCenter
            NotificationCenterStreamComponent={Drawer}
            notificationBellRef={notificationBellRef}
            headerContent={
              <NotificationCenterDrawerHeader iconName={GenericIconName.Bell} />
            }
            NewsletterSubscriptionComponent={ModalDialog}
          />
          <IconMetaNavigationItemWishlist onClick={handleClick} />
          <IconMetaNavigationItemBasket onClick={handleClick} />
        </IconMetaNavItemsWrapper>
      </IconAndContentWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
`;

const SearchIconWrapper = styled.div`
  ${tabletAndDownLinaria('display: none;')}
`;

const IconAndContentWrapper = styled.div`
  position: relative;
  height: 100%;
`;

const IconMetaNavItemsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100%;
  max-width: 100%;

  ${tabletAndUpLinaria('gap: 18px;')}
  ${desktopAndUpLinaria('gap: 32px;')}
`;
